<template>
	
		<mapbase 
		:mapColor="mapColor" 
		:mapTitle="mapTitle" 
		:mapName="mapName" 
		:unit="unit" 
		:pieces="pieces"
		:cityD="cityD"
		:provicesD="provicesD"
		/>
		<!-- <mapbase /> -->
	
</template>

<script>
	import mapbase from './mapbase.vue'
	import '../../static/js/provinceWateTotal.js'
	import '../../static/js/cityWaterTotal.js'
	export default {
		name: 'mapuse',
		components: {
			mapbase,
		},
		data(){
			return {
				cityD:cityWaterTotal,
				provicesD:provinceWateTotal,
				unit:'万立方米',
				mapName:'城市供水总量',
				mapTitle:'2018年城市供水总量地图(万立方米)',
				mapColor:['#fff', '#D8F2ED', '#A9CCC6', '#7EA8A2', '#588782', '#376B66','#154F4A'],
				pieces:[
							{
								min: 109274.780001
							}, 
							{
								min:61845.970001  ,
								max:109274.780000
							},
							{
								min: 39439.100001  ,
								max: 61845.970000
							},
							{
								min: 20563.410001  ,
								max: 39439.100000
							},
							{
								min: 8566.210001  ,
								max: 20563.410000
							},
							{
								min: 373.000000  ,
								max: 8566.210000
							},
							{
								min: 0,
								max:  373
							}
							
						]
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: calc(100vh - 200px);
		margin: auto;
		/* border: 2px solid aquamarine; */
	}
	
	.search{
		margin-right: 30px;
		text-align: right;
		margin-bottom: 20px;
	}
	.search .el-input{
		width:30%
	}
	@media screen and (max-width:600px) {
		.search .el-input{
			width:50%
		}
	}
</style>
